<template>
  <div class="input-container" :class="{ 'required-fail': requiredFail }">
    <treeselect
      :value="value"
      @input="updateValue($event)"
      :options="options"
      :load-options="loadOptions"
      :normalizer="normalizer"
      :multiple="multiple"
      :placeholder="placeholder"
      :disabled="disabled"
      :clearable="clearable"
      disableFuzzyMatching
      class="form-input-select"
    />
  </div>
</template>

<script>
import { inputTypeMixin } from "@/mixins/forms/dynamicObjectForms/inputTypeMixin";
import { mapActions } from "vuex";

export default {
  name: "InputTypeTreeSelectNPV",

  mixins: [inputTypeMixin],

  props: {
    clearable: {
      type: Boolean,
      default: true
    },

    multiple: {
      type: Boolean,
      default: false
    },

    selectOptions: {
      type: String,
      required: false
    }
  },

  data() {
    return {
      options: null
    };
  },

  methods: {
    ...mapActions(["GET_LIST"]),

    /**
     * Loads
     * the select options locally.
     */
    async loadOptions({ callback }) {
      let options = this.$store.getters.getListOfOptionsByListName(
        this.selectOptions,
        [this.value]
      );
      if(this.selectOptions != null){
      if (!!options && options.custom) {
        this.options = Object.values(options);
        this.options.pop();
        return this.options;
      } else if (!options) {
        try {
          options = await this.GET_LIST({
            listName: this.selectOptions,
            code: [this.value]
          });
        } catch (error) {
          console.log(error);
        }
      }
      }
      this.options = options;
      callback();
    },

    /**
     * Normalizes the content of each option object in the object list so it can be used in the Select input field.
     * @param {object} node - option object
     * @returns {{id: string | number, label: string}} a normalized option object.
     */
    normalizer(node) {
      let id = "";
      let label = "";
      switch (true) {
        case node.hasOwnProperty("code"):
          id = node.code;
          if (node.hasOwnProperty("client_label") && node.client_label) {
            label = node.client_label;
          } else if (node.hasOwnProperty("libelle") && node.libelle) {
            label = node.libelle;
          } else if (node.hasOwnProperty("reference") && node.reference) {
            //cableMaterialList
            label = node.reference;
          } else if (node.hasOwnProperty("name") && node.name) {
            //cableMaterialList
            label = node.name;
          } else if (
            node.hasOwnProperty("municipality_label") &&
            node.municipality_label
          ) {
            label = node.municipality_label;
          } else if (node.hasOwnProperty("libelle") && !node.libelle) {
            label = node.code;
          }
          break;
        case node.hasOwnProperty("or_id"): //OwnerList
          id = node.or_id;
          label = node.or_nom;
          break;
        case node.hasOwnProperty("pw_id"): //PathwayIdsList
          id = node.pw_id;
          label = node.pw_id;
          break;
      }
      return {
        id: id,
        label: label,
        isDisabled: node.deleted
      };
    }
  }
};
</script>

<style>
.form-input-select .vue-treeselect__control {
  background-color: #F0F0EF !important;
  width: 180px;
  border-radius: 8px;
  height: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/Npv/Configuration/components/InputTypesNPV/InputTypeTreeSelectNPV.vue